import styled from 'styled-components';

export const PaperPanelContainer = styled.div`
background: ${props => props.theme.colors.white};
padding: 36px;
border: 1px solid #ccc;
border-radius:4px;
box-shadow: 0 1px 3px 0 #ccc;
`;
